import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M5.25 12H11M5.25 12V7.75M5.25 12L5.25 16.25M11 12V7.75M11 12V16.25" strokeLinecap="square" vectorEffect="non-scaling-stroke" />
		<Path d="M17 17C17 16.1556 17 10.213 17 7.75L14 8.55556" vectorEffect="non-scaling-stroke" />
	</SVG>
);
